import { faNum, formatRial } from '@kia/shared';
import { useApiResource } from '../lib/useApiResource';
import { ErrorRetry } from '../ui';

/**
 * Compact AI-spend line, shown on both AI screens. Reads the `ai_usage` ledger via `/api/ai/usage`;
 * re-fetches whenever `refresh` changes (each screen bumps it after a call) so spend stays live.
 */

interface Usage {
  month: { ym: string; calls: number; costUsd: number; costRial: number | null };
  today: { calls: number; costUsd: number };
}

const usd = (n: number) =>
  '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

export function AiSpend({ refresh = 0 }: { refresh?: number }) {
  const { data: u, status, error, reload } = useApiResource<Usage>('/api/ai/usage', [refresh]);
  if (status === 'error') {
    return <ErrorRetry error={error} onRetry={() => reload()} />;
  }
  if (!u) return null;

  return (
    <div
      className="muted"
      style={{
        fontSize: 12,
        marginTop: 0,
        marginBottom: 8,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        alignItems: 'center',
      }}
    >
      <span>
        💳 هزینهٔ هوش مصنوعی این ماه: <b>{usd(u.month.costUsd)}</b>
        {u.month.costRial != null ? <> ‏(≈ {formatRial(u.month.costRial)})</> : null}
      </span>
      <span>· {faNum(u.month.calls)} فراخوان</span>
      {u.today.calls > 0 ? (
        <span>
          · امروز {usd(u.today.costUsd)} ({faNum(u.today.calls)} فراخوان)
        </span>
      ) : null}
    </div>
  );
}
